import * as React from "react";
import clsx from "clsx";
import { Building2, Crosshair } from "lucide-react";
import type { OrgContextOrganization } from "../../lib/organization-context/types";
import { normalizeAvatarUrl } from "../../lib/profile-avatar-image";
import * as s from "./OrgContext.css";

export interface OrganizationContextOptionProps {
  org: OrgContextOrganization;
  selected: boolean;
  disabled?: boolean;
  isMobile: boolean;
  onToggle: () => void;
  /** Selects only this org, deselecting all others. Hidden when already the sole selection. */
  onSolo: () => void;
  isSoleSelection: boolean;
}


export function OrganizationContextOption({
  org,
  selected,
  disabled = false,
  isMobile,
  onToggle,
  onSolo,
  isSoleSelection,
}: OrganizationContextOptionProps) {
  const location = [org.city, org.state].filter(Boolean).join(", ");

  return (
    <div className={s.contextOptionWrapper}>
      <button
        type="button"
        className={clsx(s.contextOption, selected && s.contextOptionSelected)}
        disabled={disabled}
        onClick={onToggle}
        aria-pressed={selected}
      >
        <span
          className={clsx(
            s.contextOptionOverlay,
            selected && s.contextOptionOverlayVisible,
          )}
          aria-hidden
        />
        <div className={s.contextOptionLogo}>
          {org.logoUrl ? (
            <img
              src={normalizeAvatarUrl(org.logoUrl) ?? org.logoUrl}
              alt=""
              className={s.logoStackImg}
            />
          ) : (
            <Building2 size={18} strokeWidth={1.75} />
          )}
        </div>
        <div className={s.contextOptionBody}>
          <div className={s.contextOptionName}>{org.name}</div>
          {location && <div className={s.contextOptionMeta}>{location}</div>}
        </div>
      </button>

      {!isSoleSelection && (
        <button
          type="button"
          className={s.contextOptionSoloBtn}
          onClick={(e) => {
            e.stopPropagation();
            onSolo();
          }}
          aria-label={`Select only ${org.name}`}
          title={`Select only ${org.name}`}
        >
          <>
            <Crosshair size={isMobile ? 14 : 12} strokeWidth={2} />
            {isMobile && <span className={s.contextOptionSoloBtnLabel}>solo</span>}
          </>
        </button>
      )}
    </div>
  );
}
